/** A git commit hash from which a build was made. Defined by Webpack. */
declare const COMMIT_ID: string;

console.log(`commit: ${COMMIT_ID}`);
